import React, { useState } from 'react';
// @ts-ignore
import styles from './MultiMediaViewerItem.module.scss';
import Checkbox from '../../../../Components/Base/Checkbox/Checkbox';
import { prepareDocumentationFileForMediaViewer } from '../../../Ecard/Services/eCardFile.service';
import MediaViewerModal from '../../../../Components/MediaViewer/MediaViewerModal';
import { useAppContext } from '../../../../Services/AppContext';

export interface IMultiMediaViewerItem {
	id: string;
	name: string;
	displayName?: string;
	description?: string | null;
	thumbUrl: string;
	createdAt: string;
	userId: string;
	folderId: string;
	file: {
		id: string;
		extension: string;
		name: string;
	};
	canBeSigned?: boolean;
}

interface Props {
	item: IMultiMediaViewerItem;
	isSelectionMode: boolean;
	isSelected: boolean;
	onSelect: (item: IMultiMediaViewerItem, isSelected: boolean) => void;
}

const MultiMediaViewerItem: React.FC<Props> = ({
	item,
	isSelectionMode = false,
	isSelected,
	onSelect,
}) => {
	const { socketUrl } = useAppContext();
	const [isPreviewOpen, setIsPreviewOpen] = useState(false);

	const handleSelectItem = () => {
		if (isSelectionMode) {
			onSelect(item, !isSelected);
		} else {
			setIsPreviewOpen(true);
		}
	};

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.imageWrapper} onClick={handleSelectItem}>
					{isSelectionMode && (
						<Checkbox value={isSelected} className={styles.checkbox} />
					)}
					<img src={item.thumbUrl} alt='item.name' />
				</div>
				<div className={styles.name}>{item.description || item.name}</div>
			</div>
			{isPreviewOpen && (
				<MediaViewerModal
					opened
					onClose={() => setIsPreviewOpen(false)}
					file={prepareDocumentationFileForMediaViewer(item, socketUrl)}
					isSignable={item.canBeSigned || false}
				/>
			)}
		</>
	);
};

export default MultiMediaViewerItem;
